<div class="mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <!-- Outer Wrapper Card -->
  <div class="ph-card mb-4">
    <div class="ph-card__body">

      <!-- Header / Filters -->
      <div class="row align-items-end mb-4 mt-3">

        <!-- Search -->
        <div class="col-12 col-lg-7 mb-2">
          <div class="position-relative">
            <input id="searchCompany" type="text" class="form-control employer-search-input shadow-none"
              placeholder="Type here..." [(ngModel)]="searchText" (input)="performSearch()" />
            <span class="search-icon" (click)="performSearch()">
              <i class="bi bi-search"></i>
            </span>
          </div>
        </div>

        <!-- Month Selector + Reset Button -->
        <div class="col-12 col-lg-5 mb-2 d-flex align-items-end gap-3 justify-content-lg-end">
          <input type="month" id="selectedMonth" class="form-control flex-fill flex-lg-grow-0" style="max-width: 160px;" [(ngModel)]="selectedMonth"
            (change)="onMonthChange()" [max]="endMonth">
          <button type="button" class="btn btn-secondary flex-fill flex-lg-grow-0" (click)="onFilterReset()"
            title="Reset to current month">
            <i class="bi bi-arrow-clockwise me-1"></i> Reset
          </button>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="filteredCompanies.length === 0 && !isLoading" class="text-center py-5">
        <i class="bi bi-inbox fs-1 text-muted mb-3 d-block"></i>
        <p class="text-muted">No Payment Records Found for the Selected Period.</p>
      </div>

      <!-- Main Table -->
      <div *ngIf="filteredCompanies.length > 0 && !isLoading" class="table-responsive-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>Company Id</th>
              <th>Company Name</th>
              <th class="right">Total Invoiced (LKR)</th>
              <th class="right">Payments Received (LKR)</th>
              <th class="right">Balance Due (LKR)</th>
              <th class="center">Due Days</th>
              <th class="center"><i class="bi bi-eye"></i></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let company of pagedCompanies">
              <td class="td-muted">{{ company.companyId }}</td>
              <td>{{ company.companyName }}</td>
              <td class="td-amount">{{ company.totalInvoicedAmount | number: '1.2-2' }}</td>
              <td class="td-amount" style="color: var(--green-text)">{{ company.totalPaymentsReceived | number: '1.2-2' }}</td>
              <td class="td-amount" [style.color]="company.balanceDue > 0 ? 'var(--red-text)' : 'var(--green-text)'">
                {{ company.balanceDue | number: '1.2-2' }}
              </td>
              <td class="td-center">
                <span [ngClass]="getDueDaysBadgeClass(company.noOfDueDays)">{{ company.noOfDueDays }}</span>
              </td>
              <td class="td-center">
                <button class="btn p-0" style="background: none; border: none;" (click)="openPaymentDetails(company)"
                  data-bs-toggle="offcanvas" data-bs-target="#paymentDetailsOffcanvas">
                  <i class="bi bi-arrow-right" style="color: var(--teal-text); font-size: 1.2rem;"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination — DO NOT CHANGE -->
        <app-paginator [dataSource]="filteredCompanies" [pageSize]="companiesPageSize"
          [pageSizeOptions]="companiesPageSizeOptions" (pageChange)="onCompanyPageChange($event)">
        </app-paginator>
      </div>

    </div>
  </div>
</div>


<!-- Payment Details Offcanvas -->
<div class="offcanvas offcanvas-end" tabindex="-1" id="paymentDetailsOffcanvas" data-bs-backdrop="false"
  data-bs-keyboard="false" aria-labelledby="paymentDetailsOffcanvasLabel" style="width: 100vw;"
  #paymentDetailsOffcanvasEl>

  <div class="offcanvas-header">
    <div class="d-flex align-items-center gap-2">
      <i class="bi bi-credit-card-2-front fs-5" style="color: var(--teal-text);"></i>
      <div>
        <h5 class="offcanvas-title mb-0" id="paymentDetailsOffcanvasLabel">
          Payment Details — {{ selectedCompany?.companyName || '-' }}
        </h5>
        <small class="text-muted">
          Company ID: {{ selectedCompany?.companyId || '-' }} |
          Period: {{ formatMonthDisplay(selectedMonth) }}
        </small>
      </div>
    </div>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body">
    <ng-container *ngIf="selectedCompany">

      <!-- Stat Cards -->
      <div class="stats-grid">

        <div class="stat-card">
          <div class="stat-icon stat-icon--blue">
            <i class="bi bi-receipt"></i>
          </div>
          <div class="stat-body">
            <div class="stat-label">Total Invoiced</div>
            <div class="stat-value">{{ selectedCompany.totalInvoicedAmount | number: '1.2-2' }}</div>
            <div class="stat-currency">LKR</div>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon stat-icon--green">
            <i class="bi bi-cash-stack"></i>
          </div>
          <div class="stat-body">
            <div class="stat-label">Payments Received</div>
            <div class="stat-value stat-value--green">{{ selectedCompany.totalPaymentsReceived | number: '1.2-2' }}</div>
            <div class="stat-currency">LKR</div>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon stat-icon--amber">
            <i class="bi bi-exclamation-circle"></i>
          </div>
          <div class="stat-body">
            <div class="stat-label">Balance Due</div>
            <div class="stat-value stat-value--amber">{{ selectedCompany.balanceDue | number: '1.2-2' }}</div>
            <div class="stat-currency">LKR</div>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon" [ngClass]="selectedCompany.noOfDueDays > 0 ? 'stat-icon--amber' : 'stat-icon--teal'">
            <i class="bi bi-calendar-check"></i>
          </div>
          <div class="stat-body">
            <div class="stat-label">Due Days</div>
            <div class="stat-value" [ngClass]="selectedCompany.noOfDueDays > 0 ? 'stat-value--amber' : ''">
              {{ selectedCompany.noOfDueDays }}
            </div>
            <div class="stat-currency">days overdue</div>
          </div>
        </div>

      </div>

      <!-- Empty State for Details -->
      <div *ngIf="paymentSummary.length === 0" class="text-center py-4">
        <i class="bi bi-inbox fs-1 text-muted mb-3 d-block"></i>
        <p class="text-muted">No payment details found for this period.</p>
      </div>

      <!-- Level 1: Summary Table -->
      <div *ngIf="paymentSummary.length > 0">
        <!-- Section Header -->
        <div class="section-header">
          <span class="section-title">Payment Breakdown</span>
        </div>
        <div class="sub-table-wrap">
          <div class="table-responsive-wrapper">
            <table class="sub-table">
              <thead>
                <tr>
                  <th style="width: 36px;"></th>
                  <th>Payment Type</th>
                  <th>Salary Cycle</th>
                  <th class="center">Invoice Date</th>
                  <th class="center">Due Date</th>
                  <th class="right">Invoice Value (LKR)</th>
                  <th class="right">Payment Value (LKR)</th>
                  <th class="center">Payment Date</th>
                  <th class="right">Due Amount (LKR)</th>
                  <th class="center">Due Days</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let summary of pagedPaymentSummary">

                  <!-- Level 1 Row -->
                  <tr [class.is-expanded]="isRowExpanded(summary)">
                    <td class="td-center">
                      <button class="expand-btn" [class.open]="isRowExpanded(summary)"
                        (click)="toggleRowExpansion(summary)">
                        <i class="bi bi-chevron-right"></i>
                      </button>
                    </td>
                    <td>
                      <span [ngClass]="getPaymentTypeBadgeClass(summary.paymentType)" class="ph-badge">
                        {{ getPaymentTypeLabel(summary.paymentType) }}
                      </span>
                    </td>
                    <td class="td-muted">{{ summary.salaryCycle }}</td>
                    <td class="td-muted td-center">{{ summary.invoiceDate | date: 'yyyy-MM-dd' }}</td>
                    <td class="td-muted td-center">{{ summary.dueDate | date: 'yyyy-MM-dd' }}</td>
                    <td class="td-muted td-right">{{ summary.invoiceValue | number: '1.2-2' }}</td>
                    <td class="td-amount">{{ summary.paymentValue | number: '1.2-2' }}</td>
                    <td class="td-center">
                      <span *ngIf="summary.paymentDate" class="date-pill">
                        {{ summary.paymentDate | date: 'yyyy-MM-dd' }}
                      </span>
                      <span *ngIf="!summary.paymentDate" class="td-muted" style="font-size:12px;">Not Paid</span>
                    </td>
                    <td class="td-amount" [style.color]="summary.dueAmount > 0 ? 'var(--red-text)' : 'var(--green-text)'">
                      {{ summary.dueAmount | number: '1.2-2' }}
                    </td>
                    <td class="td-center">
                      <span [ngClass]="getDueDaysBadgeClass(summary.noOfDueDays)">{{ summary.noOfDueDays }}</span>
                    </td>
                  </tr>

                  <!-- Level 2: Invoice Detail Expansion -->
                  <tr *ngIf="isRowExpanded(summary)">
                    @if (getChildInvoices(summary).length > 0) {
                      <td colspan="10" class="expand-cell">
                        <div class="expand-inner">
                          <div class="nested-label">Invoice Detail</div>
                          <div class="sub-table-wrap">
                            <table class="sub-table">
                              <thead>
                                <tr>
                                  <th style="width: 32px;"></th>
                                  <th>Invoice ID</th>
                                  <th>Invoice #</th>
                                  <th>Reference</th>
                                  <th class="center">Invoice Date</th>
                                  <th class="center">Due Date</th>
                                  <th class="right">Invoice Value (LKR)</th>
                                  <th class="right">Payment Value (LKR)</th>
                                  <th class="center">Payment Date</th>
                                  <th class="right">Due Amount (LKR)</th>
                                  <th class="center">Status</th>
                                  <th class="center">Due Days</th>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngFor="let invoice of getChildInvoices(summary)">

                                  <!-- Level 2 Row -->
                                  <tr>
                                    <td class="td-center">
                                      <button *ngIf="getSlipsForInvoice(invoice).length > 0"
                                        class="expand-btn" [class.open]="isInvoiceExpanded(invoice.invoiceId)"
                                        (click)="toggleInvoiceExpansion(invoice.invoiceId)">
                                        <i class="bi bi-chevron-right"></i>
                                      </button>
                                    </td>
                                    <td class="td-muted">{{ invoice.invoiceId }}</td>
                                    <td class="td-muted">{{ invoice.invoiceNumber }}</td>
                                    <td class="td-muted">{{ invoice.invoiceReference }}</td>
                                    <td class="td-muted td-center">{{ invoice.invoiceDate | date: 'yyyy-MM-dd' }}</td>
                                    <td class="td-muted td-center">{{ invoice.dueDate | date: 'yyyy-MM-dd' }}</td>
                                    <td class="td-muted td-right">{{ invoice.invoiceValue | number: '1.2-2' }}</td>
                                    <td class="td-amount"
                                      [style.color]="invoice.status === 'Rejected' ? 'var(--red-text)' : 'var(--green-text)'">
                                      {{ invoice.paymentValue | number: '1.2-2' }}
                                    </td>
                                    <td class="td-center">
                                      <span *ngIf="invoice.paymentDate" class="date-pill"
                                        [style.background]="invoice.status === 'Rejected' ? 'var(--red-bg)' : null"
                                        [style.color]="invoice.status === 'Rejected' ? 'var(--red-text)' : null"
                                        [style.border-color]="invoice.status === 'Rejected' ? 'var(--red-border)' : null">
                                        {{ invoice.paymentDate | date: 'yyyy-MM-dd' }}
                                      </span>
                                      <span *ngIf="!invoice.paymentDate" style="color: var(--text-muted); font-size:12px;">Not Paid</span>
                                    </td>
                                    <td class="td-amount"
                                      [style.color]="invoice.dueAmount > 0 ? 'var(--red-text)' : 'var(--green-text)'">
                                      {{ invoice.dueAmount | number: '1.2-2' }}
                                    </td>
                                    <td class="td-center">
                                      <span [ngClass]="getInvoiceStatusBadgeClass(invoice.status)" class="ph-status">
                                        {{ invoice.status }}
                                      </span>
                                    </td>
                                    <td class="td-center">
                                      <span [ngClass]="getDueDaysBadgeClass(invoice.noOfDueDays)">{{ invoice.noOfDueDays }}</span>
                                    </td>
                                  </tr>

                                  <!-- Level 3: Payslips expansion -->
                                  <tr *ngIf="isInvoiceExpanded(invoice.invoiceId)">
                                    <td colspan="12" class="expand-cell">
                                      <div class="expand-inner slip-expand-wrap">
                                        <div class="nested-label">Payslip Versions</div>
                                        <div class="sub-table-wrap">
                                          <table class="sub-table">
                                            <thead>
                                              <tr>
                                                <th class="center">Version</th>
                                                <th>Method</th>
                                                <th class="center">Payment Date</th>
                                                <th class="right">Payment Value (LKR)</th>
                                                <th class="right">Balance Before (LKR)</th>
                                                <th class="right">Balance After (LKR)</th>
                                                <th class="center">Slip</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr *ngFor="let slip of getSlipsForInvoice(invoice)">
                                                <td class="td-center">
                                                  <span [ngClass]="getVersionBadgeClass(slip)" class="v-badge">
                                                    {{ getSlipVersionLabel(slip) }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span [ngClass]="getSlipMethodBadgeClass(slip)" class="ph-badge">
                                                    {{ slip.paymentMethod }}
                                                  </span>
                                                </td>
                                                <td class="td-muted td-center">{{ slip.paymentDate | date: 'yyyy-MM-dd' }}</td>
                                                <td class="td-amount">{{ slip.paymentValue | number: '1.2-2' }}</td>
                                                <td class="td-muted td-right">{{ slip.balanceBefore | number: '1.2-2' }}</td>
                                                <td class="td-muted td-right">{{ slip.balanceAfter | number: '1.2-2' }}</td>
                                                <td class="td-center">
                                                  <button class="ph-download-btn"
                                                    [disabled]="!slip.paySlipUrl"
                                                    (click)="downloadSlip(slip)"
                                                    [title]="slip.paySlipUrl ? 'Download payment slip' : 'Slip not available'">
                                                    <i class="bi bi-download"></i>
                                                    Download
                                                  </button>
                                                </td>
                                              </tr>
                                              <tr *ngIf="getSlipsForInvoice(invoice).length === 0">
                                                <td colspan="7" class="td-center" style="color: var(--text-muted); font-size:12px; padding: 14px;">
                                                  No payment slips available
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>

                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </td>
                    } @else {
                      <td colspan="10">
                        <div class="text-center py-4">
                          <i class="bi bi-inbox fs-2 d-block mb-2" style="color: var(--text-muted);"></i>
                          <p style="color: var(--text-muted); font-size: 13px; margin: 0;">No invoice records found for this payment.</p>
                        </div>
                      </td>
                    }
                  </tr>

                </ng-container>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Details Pagination — DO NOT CHANGE -->
        <app-paginator *ngIf="paymentSummary.length > 0" [dataSource]="paymentSummary" [pageSize]="detailsPageSize"
          [pageSizeOptions]="detailsPageSizeOptions" (pageChange)="onDetailsPageChange($event)">
        </app-paginator>
      </div>

    </ng-container>
  </div>
</div>